import React, { useState, useCallback, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";
import { Form, FormGroup, Label, Input, FormText } from "reactstrap";
import { Fade } from "react-reveal";
import { useNavigate, useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { sendOtp, verifyOtp, getKyc } from "store/actions";
import Loader from "Component/Common/Loader";
import { useTranslation } from "react-i18next";
import useToastr from "helpers/toastr"; // Adjust the path accordingly

const OtpVerify = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();

  const fieldsInfo = location?.state;
  const { loading } = useSelector(({ SendOtp, Register }) => ({
    loading: SendOtp.loading || Register.loading,
  }));
  const { t } = useTranslation();
  const toastr = useToastr();
  const [passwordType, setPasswordType] = useState("password");

  const [fields, setFields] = useState({
    otp: "",
  });

  const togglePassword = () => {
    if (passwordType === "password") {
      setPasswordType("text");
      return;
    }
    setPasswordType("password");
  };

  const handleChange = (name) => (e) => {
    if (name.toLowerCase() === "otp") {
      const regex = /^[0-9]*$/;
      const inputValue = e.target.value;

      // Check if input value matches regex and has a length less than or equal to 6
      if (!regex.test(inputValue) || inputValue.length > 6) {
        return;
      }
    }

    // Update the state with the new value
    setFields((prev) => ({ ...prev, [name]: e.target.value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (fields.otp.trim() === "") {
      return toastr.error(t("enter-otp"));
    }
    if (fields.otp.trim().length !== 4) {
      return toastr.error(t("six-digit-otp"));
    }

    const callback = (response) => {
      if (response.status === "success") {
        const successMessage =
          fieldsInfo?.path === "signin"
            ? t("login_successfully")
            : t("registered_success");
        toastr.success(successMessage);
        const redirectPath = response?.data?.kycDetails?.verified
          ? "/"
          : "/kyc";
        setTimeout(() => {
          navigate(redirectPath);
        }, 35);
      } else {
        toastr.error(response.message);
      }
    };

    dispatch(
      verifyOtp(
        { role: fieldsInfo?.role, email: fieldsInfo?.email, OTP: fields.otp },
        callback
      )
    );
  };

  const otpFunction = () => {
    const callback = (response) => {
      if (response.status == "success") {
        return toastr.success(t("code-sent"));
      } else {
        return toastr.error(response.message);
      }
    };
    dispatch(
      sendOtp({ role: fieldsInfo?.role, email: fieldsInfo?.email }, callback)
    );
  };

  const resendOtp = (e) => {
    e.preventDefault();
    otpFunction();
  };

  const handleBack = () => {
    navigate(-1);
  };

  return (
    <section className="common_sign_main sign_in p-3">
      {loading && <Loader />}
      <Container fluid>
        <div className="common_sign_inner">
          <Row>
            <Col lg={5} md={6} sm={12} className="order-2 order-lg-1">
              <Fade>
                <div className="left_form_part common_box_wrap">
                  <div className="arrow_with_head">
                    <svg
                      role="button"
                      onClick={handleBack}
                      width="30"
                      height="30"
                      class="w-6 h-6 text-gray-800 dark:text-white mb-5"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 14 10"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M13 5H1m0 0 4 4M1 5l4-4"
                      />
                    </svg>
                    <h3 className="sign_head mobile_auth_head">
                      {t("cretae_account")}
                    </h3>
                  </div>
                  <Form className="form_sign_inout">
                    <h2 className="sign_head">{t("email-verification")}</h2>
                    <Row>
                      <Col lg={12} sm={12}>
                        <FormGroup className="position-relative">
                          <Label for="examplePassword">
                            {t("enter-verification-code")}
                          </Label>
                          <Input
                            name="otp"
                            type={passwordType}
                            id="otp"
                            value={fields.otp}
                            placeholder={t("verification-code")}
                            onChange={handleChange("otp")}
                            maxLength={"6"}
                          />
                          {passwordType === "password" ? (
                            <Button
                              className="eye_btn"
                              onClick={togglePassword}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 256 256"
                              >
                                <path
                                  fill="#9BA1B3"
                                  d="M53.92 34.62a8 8 0 1 0-11.84 10.76l19.24 21.17C25 88.84 9.38 123.2 8.69 124.76a8 8 0 0 0 0 6.5c.35.79 8.82 19.57 27.65 38.4C61.43 194.74 93.12 208 128 208a127.11 127.11 0 0 0 52.07-10.83l22 24.21a8 8 0 1 0 11.84-10.76Zm47.33 75.84l41.67 45.85a32 32 0 0 1-41.67-45.85M128 192c-30.78 0-57.67-11.19-79.93-33.25A133.16 133.16 0 0 1 25 128c4.69-8.79 19.66-33.39 47.35-49.38l18 19.75a48 48 0 0 0 63.66 70l14.73 16.2A112 112 0 0 1 128 192m6-95.43a8 8 0 0 1 3-15.72a48.16 48.16 0 0 1 38.77 42.64a8 8 0 0 1-7.22 8.71a6.39 6.39 0 0 1-.75 0a8 8 0 0 1-8-7.26A32.09 32.09 0 0 0 134 96.57m113.28 34.69c-.42.94-10.55 23.37-33.36 43.8a8 8 0 1 1-10.67-11.92a132.77 132.77 0 0 0 27.8-35.14a133.15 133.15 0 0 0-23.12-30.77C185.67 75.19 158.78 64 128 64a118.37 118.37 0 0 0-19.36 1.57A8 8 0 1 1 106 49.79A134 134 0 0 1 128 48c34.88 0 66.57 13.26 91.66 38.35c18.83 18.83 27.3 37.62 27.65 38.41a8 8 0 0 1 0 6.5Z"
                                />
                              </svg>
                            </Button>
                          ) : (
                            <Button
                              className="eye_btn"
                              onClick={togglePassword}
                            >
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="25"
                                height="25"
                                viewBox="0 0 256 256"
                              >
                                <path
                                  fill="#9BA1B3"
                                  d="M245.48 125.57c-.34-.78-8.66-19.23-27.24-37.81C201 70.54 171.38 50 128 50S55 70.54 37.76 87.76c-18.58 18.58-26.9 37-27.24 37.81a6 6 0 0 0 0 4.88c.34.77 8.66 19.22 27.24 37.8C55 185.47 84.62 206 128 206s73-20.53 90.24-37.75c18.58-18.58 26.9-37 27.24-37.8a6 6 0 0 0 0-4.88M128 194c-31.38 0-58.78-11.42-81.45-33.93A134.77 134.77 0 0 1 22.69 128a134.56 134.56 0 0 1 23.86-32.06C69.22 73.42 96.62 62 128 62s58.78 11.42 81.45 33.94A134.56 134.56 0 0 1 233.31 128C226.94 140.21 195 194 128 194m0-112a46 46 0 1 0 46 46a46.06 46.06 0 0 0-46-46m0 80a34 34 0 1 1 34-34a34 34 0 0 1-34 34"
                                />
                              </svg>
                            </Button>
                          )}
                        </FormGroup>
                      </Col>
                    </Row>

                    <div className="dont_have_accoutn text-center pt-4">
                      <label>
                        {t("sent-code")} <br></br>"{fieldsInfo?.email + " "}".{" "}
                        {t("check-spam")}
                      </label>
                    </div>
                    <Button
                      disabled={fields.otp.length !== 4 && true}
                      className="btn_sign_in btn_theme w-100 mt-4"
                      onClick={handleSubmit}
                    >
                      {t("continue")}
                    </Button>

                    <div className="dont_have_accoutn text-center pt-4">
                      <p>
                        {t("no-code")}{" "}
                        <Link to="" onClick={resendOtp}>
                          {t("click-here")}
                        </Link>
                      </p>
                    </div>
                  </Form>
                </div>
              </Fade>
            </Col>

            <Col lg={7} md={6} sm={12} className="order-1 order-lg-2">
              <Fade>
                <div className="right_gradient_part position-relative">
                  <Link to="/" className="logo">
                    <img
                      src="images/logo.svg"
                      alt="logo"
                      className="img-fluid"
                    />
                  </Link>
                  <div className="signingimg_bottom">
                    <img
                      src="/images/signinimg.png"
                      alt=""
                      className="img-fluid"
                    />
                  </div>

                  <div className="right_gradient_text">
                    <h4>{t("track_crypto")}</h4>
                    <p>{t("login_ispublish")}</p>
                  </div>
                </div>
              </Fade>
            </Col>
          </Row>
        </div>
      </Container>
    </section>
  );
};

export default OtpVerify;
